import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { ExpandableTextComponent } from './expandable-text.component';

@NgModule({
    declarations: [
        ExpandableTextComponent
    ],
    imports: [
        CommonModule,
        ButtonModule
    ],
    exports:[
        ExpandableTextComponent
    ]
})
export class ExpandableTextModule { }
